import { ScanWalletAddress } from 'BreetComponents';
import { useUsdWithdrawRequestContext } from 'BreetHooks';
import { useCallback } from 'react';

const DialogWithdrawUsdScanWalletAddress = () => {
	const { formDataContextProps, formStage } = useUsdWithdrawRequestContext();

	const { setValueAndValidate } = formDataContextProps;

	const handleClose = useCallback(() => {
		formStage.navigator.reset();
		formStage.navigator.goTo('withdraw-funds')();
	}, [formStage]);

	const handleScannedAddress = useCallback(
		async (address: string) => {
			await setValueAndValidate('receiverAddress', address);
			handleClose();
		},
		[setValueAndValidate, handleClose]
	);

	return (
		<ScanWalletAddress
			handleClose={handleClose}
			validateAddress={handleScannedAddress}
		/>
	);
};

export default DialogWithdrawUsdScanWalletAddress;
